import React, { Component } from 'react';

class About extends Component {

  state = {

  }

  componentDidMount() {

  }

  render() {

    return (
      <div className="AboutPage">
                About
      </div>
    );
  }

}

export default About;


// WEBPACK FOOTER //
// ./src/components/content/about/about.js